import { Modal as AntModal, ButtonProps } from 'antd';
import React, { useState } from 'react';

interface Props {
  open?: boolean;
  title?: string;
  width?: number;
  target?: React.ReactNode;
  children: React.ReactNode;
  onClose?: () => void;
  cancelButtonProps?: ButtonProps;
  footer?: React.ReactNode;
  loading?: boolean;
}

const Modal = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    target,
    children,
    open,
    width,
    onClose = () => setIsOpen(false),
    title,
    footer,
    cancelButtonProps,
    loading,
  } = props;

  return (
    <div style={{ display: 'inline' }}>
      {target}
      <AntModal
        title={title}
        centered
        open={isOpen || open}
        onOk={onClose}
        footer={footer}
        onCancel={onClose}
        width={width}
        loading={loading}
        cancelButtonProps={cancelButtonProps}
      >
        {children}
      </AntModal>
    </div>
  );
};

export default Modal;
